<template>
    <div class="d-flex flex-grow-1 h-100">
        <FindNearbyEmployees
            v-if="showNearbyEmpPanel"
            v-model:showNearbyEmpPanel="showNearbyEmpPanel"
            :selectedPatientVisit="selectedVisitDetails"
            :patientInfoWindowContent="patientInfoWindow"
            :date="date"
        />
        <div
            v-else-if="zipNotEntered"
            class="d-flex flex-column align-items-center justify-content-center flex-grow-1 text-center px-3"
        >
            <p class="font-size-md mb-2">Provide your location to view Map.</p>
            <button class="btn btn-xs btn-primary" @click="enterLocation()">ENTER LOCATION</button>
        </div>
        <div v-else class="flex-grow-1" id="Patient__VisitMap">
            <div class="d-flex w-100 justify-content-center mt-4">
                <i class="fas fa-spinner fa-pulse fa-fw"></i>
                <b class="mx-2">Waiting for your location</b>
                <i class="fas fa-spinner fa-pulse fa-fw"></i>
            </div>
        </div>
    </div>
</template>

<style src="./PatientVisitMap.scss"></style>
<script lang="ts" src="./PatientVisitMap.ts"></script>
